// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Placeholder--placeholder--3ZyUn","shimmer":"Placeholder--shimmer--2VWbR"};